import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_SAVE_FILTER_QUERY_KEY } from "../types/CommonTypes";
import { queryClient } from "../../../utils/ReactQueryConfig";

async function createSavedFilter(
  tenantId: any,
  hospitalId: any,
  filterData: any
) {
  const { data } = await fetcher({
    url: `/hospital/custom-filters`,
    method: "POST",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
    data: filterData,
  });
  return data;
}

export default function useCreateSavedFilterMutation(
  tenantId: any,
  hospitalId: any
) {
  return useMutation({
    mutationFn: (filterData) =>
      createSavedFilter(tenantId, hospitalId, filterData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_SAVE_FILTER_QUERY_KEY, tenantId, hospitalId],
      });
    },
    onError: (error) => {
      console.error("Error saving filter:", error);
    },
  });
}
